import { FC, useCallback } from 'react';
import { INavTabItem, ITabItem } from '../helpers/tabs.types';
import NavTabLink from './NavTabLink';
import { twMerge } from 'tailwind-merge';
import { instanceOfINavTabItem } from '../helpers/tabs.utils';
import styles from './NavTabPills.module.scss';

interface NavTabPillsProps {
    items: INavTabItem[] | ITabItem[];
    value?: string;
    onChange?: (val: string) => void;
}

const NavTabPills: FC<NavTabPillsProps> = (props) => {
    const { items, value, onChange } = props;

    const renderNavTabLink = useCallback((item: INavTabItem, index: number) => {
        return (
            <NavTabLink key={index} className={styles['nav-pill-link']} to={item.to}>
                {(isActive: boolean) => (
                    <>{typeof item.content === 'function' ? item.content(isActive) : item.content}</>
                )}
            </NavTabLink>
        );
    }, []);

    const renderTabLink = useCallback(
        (item: ITabItem, index: number) => {
            return (
                <button
                    key={index}
                    className={twMerge(styles['nav-pill-link'], item.value === value && styles['active'])}
                    onClick={() => onChange(item.value)}
                >
                    {item.content}
                </button>
            );
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [value]
    );

    return (
        <div className="flex items-center gap-2 h-full">
            {items.map((item, i) => {
                if (instanceOfINavTabItem(item)) return renderNavTabLink(item as INavTabItem, i);

                return renderTabLink(item as ITabItem, i);
            })}
        </div>
    );
};

export default NavTabPills;
